export default function urlToImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    try {
      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        resolve(img);
      };

      img.src = url;
    } catch (err) {
      reject(err);
    }
  });
}
